import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*
// PPGRUPA PRB
U IZRADI
ovo je zapravo GRUPA OD 2 POLUPROIZVODA koji se zajednicki unose i izracunavaju ali mogu i posebno

TODO:
- 

*/


export const draftel_codecs_pack_terkk$_bundle_prigusivacbuke = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_prigusivacbuke.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_prigusivacbuke',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR
    _subform_arr_subpp_prbkulisa: [], // SUBFORM ARR
    _subform_arr_subpp_prbnosac: [], // SUBFORM ARR
    // _protobomp_subpp_prbkulisa: protobomp_manipulator.init(true),
    // _protobomp_subpp_prbnosac: _protobomp_example_make(),
    // _protobomp_subpp_prbnosac: protobomp_manipulator.init(true),
    // _protobomp: protobomp_manipulator.init(true),
    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$prigusivacbuke", null), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input

    kolicina: 0,
    prbkulisa_kolicina: 0,
    prbnosac_kolicina: 0,

    // materijali
    tipmetalalima: null,
    prbkulisa_materijal_lim: null,
    prbkulisa_materijal_kamenavuna: null,
    prbnosac_materijal_lim: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_prigusivacbuke.default_pods_input_state = () => {
  /*
  return {

  };
  */
  return default_pods_input_state_smart_get('terkk$prigusivacbuke');
};


draftel_codecs_pack_terkk$_bundle_prigusivacbuke.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_prigusivacbuke_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_prigusivacbuke.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 

  ...Object.keys(draftel_codecs_pack_terkk$_bundle_prigusivacbuke.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_prigusivacbuke.default_subform_item_preset_state())
];


/////////


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------
// NE KORISTI SE jer je ovaj draftel prebacen na protobomp koncept




// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING

